import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function ProductionEquipment() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/produktionsudstyr-specialmaskine.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-cff9eab60c19441fbcd0a9e6e378026e-mv2.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-f13a7513b1d94a9ca64d009f1172fcf7-mv2.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Produktionsudstyr - JARCon ApS"
        description="Specialudstyr, produktionshjælpemidler, maskinløsninger, montage og tilpasninger. Produktionsadresse på Huholt 1A, 6400 Sønderborg."
      />

      <PageHeader
        badge="Industrielt Udstyr"
        title="Produktionsudstyr"
        subtitle="Specialudstyr • Produktionshjælpemidler • Maskinløsninger • Montage og tilpasninger"
        breadcrumbs={[{ label: 'Produktionsudstyr' }]}
        ctaText="Hør om produktionsudstyr"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Værksted &amp; Fremstilling
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Specialudstyr og produktionshjælpemidler
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Optimering af eksisterende produktionsmaskiner og produkter samt konstruktion og opbygning af nyt udstyr.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Vi bygger specialudstyr tilpasset industriens krav til robusthed og præcision. Vores produktionsværksted på Huholt 1A i Sønderborg danner rammen om mekanisk samling, tilpasning og elektrisk opbygning.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-industry" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">Specialudstyr</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Kundespecifikke aggregater, stationer til kvalitetskontrol, sorteringsenheder og transportbåndsløsninger.
                </p>
              </div>

              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-wrench" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">Produktionshjælpemidler</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Ergonomiske montagestationer, opspændingsværktøjer og mekaniske hjælpemidler der letter operatørens arbejde.
                </p>
              </div>
            </div>

            <div className="p-6 rounded-xl bg-slate-900/60 border border-slate-800 flex items-center justify-between gap-4">
              <div>
                <h4 className="font-display font-bold text-white text-base">Søger du specialværktøj og fiksturer?</h4>
                <p className="text-xs text-slate-400 mt-1">Se vores dedikerede side for værktøjsløsninger.</p>
              </div>
              <Link
                to="/vaerktoj"
                className="px-4 py-2 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs shrink-0 transition-colors"
              >
                Gå til Værktøj &rarr;
              </Link>
            </div>

            <GalleryGrid
              title="Produktionsudstyr galleri"
              subtitle="Klik på billederne for at åbne i fuld skærm"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Udstyrsområder
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Specialudstyr og maskinløsninger</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Produktionshjælpemidler</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Mekanisk opbygning og tilpasning</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Montage og indkøring</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Produktion: Huholt 1A, 6400 Sønderborg</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Behov for nyt produktionsudstyr?
              </span>
              <p className="text-xs text-slate-300">
                Kontakt JARCon og hør hvordan vi kan tilpasse udstyret til netop din linje.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
